import * as angular from 'angular';
import * as _ from 'lodash';

import { ILoggerService, IAuthorizationService } from './';

export interface IstateAuthorizationService {
    canAccess: (stateName: string) => boolean;
}

export class StateAuthorizationService implements IstateAuthorizationService {
    static serviceId = 'stateAuthorizationService';
    static $inject = ['$state', '$q', 'authorizationService', 'loggerService'];

    constructor(
        private $state: angular.ui.IStateService,
        private $q: angular.IQService,
        private authorizationService: IAuthorizationService,
        private loggerService: ILoggerService
    ) {
    }

    canAccess(stateName: string): boolean {
        const state = this.$state.get(stateName);
        let result = true;
        if (state) {
            result = this.check(state);
            if (result && stateName.indexOf('.') > 0) {
                try {
                    const split = stateName.split('.');
                    if (split.length > 1) {
                        const parentName = split.slice(0, split.length - 1).join('.');
                        result = this.canAccess(parentName);
                    }
                }
                catch (e) {
                    this.loggerService.logError(e, false);
                }
            }
        }

        return result;
    }

    private check(state: angular.ui.IState): boolean {
        let result = !!state;
        if (state?.resolve) {
            const keys = Object.keys(state.resolve)
                .filter(k => {
                    let isOk = k !== 'user';
                    if (isOk) {
                        const resolve = state.resolve[k];
                        isOk = resolve.constructor === Array
                            && resolve.length > 0
                            && resolve[0] === 'authorizationService';
                    }
                    return isOk;
                });
            for (const key of keys) {
                try {
                    // use the last of the array, not the third
                    result = !state.resolve[key].slice(-1)[0](this.authorizationService, this.$q);
                    if (!result) {
                        break;
                    }
                }
                catch (e) {
                    this.loggerService.logError(e, false);
                    this.loggerService.logError(`State:${state.name}; key: ${key}`, false);
                }
            }
        }
        return result && !(this.authorizationService.isConnected() && state.data.hideWhenConnected);
    }
}